export default "__VITE_ASSET__33ac70ba__"